module.exports = __webpack_public_path__ + "static/media/comprecar.fc27e101.png";